import React from 'react'
import Typography from 'aldoo-ra/Typography'
import Button from 'aldoo-ra/Button'
import Modal from 'aldoo-ra/Modal'

const CSVFormatExamplePanel = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant="admin_compact"
      className="max-w-3xl"
    >
      <div className="p-6">
        <Typography component="h1" variant="admin_h3" className="mb-4">
          CSV Format Example
        </Typography>

        <Typography variant="admin_txt1" className="mb-4">
          Your CSV file should include the following columns:
        </Typography>

        <div className="bg-admin_canvas rounded-lg p-4 mb-4 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-admin_bordered">
                <th className="p-2 text-admin_text font-semibold">Column</th>
                <th className="p-2 text-admin_text font-semibold">Description</th>
                <th className="p-2 text-admin_text font-semibold">Required</th>
                <th className="p-2 text-admin_text font-semibold">Example</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_primary">email</td>
                <td className="p-2 text-admin_text">Email address</td>
                <td className="p-2 text-admin_primary font-semibold">Yes</td>
                <td className="p-2 text-admin_text_secondary">user@example.com</td>
              </tr>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_text">name</td>
                <td className="p-2 text-admin_text">Subscriber name</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">John Doe</td>
              </tr>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_text">language</td>
                <td className="p-2 text-admin_text">Language code</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">en, fr, de</td>
              </tr>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_text">registered</td>
                <td className="p-2 text-admin_text">Has user account</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">yes, no</td>
              </tr>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_text">subscribed</td>
                <td className="p-2 text-admin_text">Subscription status</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">yes, no</td>
              </tr>
              <tr className="border-b border-admin_bordered">
                <td className="p-2 font-mono text-admin_text">subscribedAt</td>
                <td className="p-2 text-admin_text">Subscribe date</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">2024-01-15</td>
              </tr>
              <tr>
                <td className="p-2 font-mono text-admin_text">platforms</td>
                <td className="p-2 text-admin_text">Platform list</td>
                <td className="p-2 text-admin_text_secondary">No</td>
                <td className="p-2 text-admin_text_secondary">android, ios, web</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-admin_neutral_1 rounded-lg p-4">
          <Typography variant="admin_body1" className="font-semibold mb-2">
            Example CSV Content:
          </Typography>
          <pre className="text-admin_text_secondary text-sm overflow-x-auto">
{`email,name,language,registered,subscribed,subscribedAt,platforms
user@example.com,John Doe,en,yes,yes,2024-01-15,"android, ios"
jane@example.com,Jane Smith,fr,no,yes,2024-01-16,web`}
          </pre>
        </div>

        <div className="flex justify-end mt-6">
          <Button variant="admin_secondary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default CSVFormatExamplePanel
